"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _contentType = require("@insided/shared/utils/contentType");

var _CreateTopic = _interopRequireDefault(require("@insided/control/modules/Content/CreateTopic"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ArticleCreator = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ArticleCreator, _PureComponent);

  var _super = _createSuper(ArticleCreator);

  function ArticleCreator() {
    (0, _classCallCheck2.default)(this, ArticleCreator);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ArticleCreator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          inGroup = _this$props.inGroup,
          enabledLanguages = _this$props.enabledLanguages,
          publishedLanguages = _this$props.publishedLanguages,
          communityLanguage = _this$props.communityLanguage;
      return (0, _preact.h)(_CreateTopic.default, {
        contentType: _contentType.CONTENT_TYPE_ARTICLE,
        id: id,
        inGroup: inGroup,
        attachmentsAllowed: true,
        featuredImageAllowed: true,
        previewAllowed: true,
        isDraftAllowed: true,
        pollAllowed: true,
        publicLabelAllowed: true,
        scheduleAllowed: true,
        stickyAllowed: true,
        versionHistoryAllowed: true,
        categoryV2Allowed: true,
        enabledLanguages: enabledLanguages,
        publishedLanguages: publishedLanguages,
        communityLanguage: communityLanguage
      });
    }
  }]);
  return ArticleCreator;
}(_preactCompat.PureComponent);

var _default = ArticleCreator;
exports.default = _default;